"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenTradeCompleteRepository = void 0;
var typeorm_1 = require("typeorm");
var OpenTradeComplete_entity_1 = require("../entities/Common/OpenTradeComplete.entity");
var OpenTradeCompleteRepository = /** @class */ (function (_super) {
    __extends(OpenTradeCompleteRepository, _super);
    function OpenTradeCompleteRepository() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OpenTradeCompleteRepository.prototype.findByTeamAndRound = function (teamID, roundID) {
        return this.createQueryBuilder('otc')
            .leftJoinAndSelect('otc.receivingTeam', 'receivingTeam')
            .leftJoinAndSelect('otc.openTrade', 'ot')
            .leftJoinAndSelect('ot.offeringTeam', 'offeringTeam')
            .leftJoinAndSelect('ot.market', 'market')
            .where(new typeorm_1.Brackets(function (qb) {
            qb.where('offeringTeam = :teamID', {
                teamID: teamID
            }).orWhere('receivingTeam = :teamID', { teamID: teamID });
        }))
            .andWhere('ot.startRoundID <= :roundID', { roundID: roundID })
            .andWhere('ot.endRoundID >= :roundID', { roundID: roundID })
            .getMany();
    };
    OpenTradeCompleteRepository.prototype.findByRound = function (roundID) {
        return this.createQueryBuilder('otc')
            .leftJoinAndSelect('otc.receivingTeam', 'receivingTeam')
            .leftJoinAndSelect('otc.openTrade', 'ot')
            .leftJoinAndSelect('ot.offeringTeam', 'offeringTeam')
            .leftJoinAndSelect('ot.market', 'market')
            .where('ot.startRoundID <= :roundID', { roundID: roundID })
            .andWhere('ot.endRoundID >= :roundID', { roundID: roundID })
            .getMany();
    };
    OpenTradeCompleteRepository = __decorate([
        (0, typeorm_1.EntityRepository)(OpenTradeComplete_entity_1.OpenTradeComplete)
    ], OpenTradeCompleteRepository);
    return OpenTradeCompleteRepository;
}(typeorm_1.Repository));
exports.OpenTradeCompleteRepository = OpenTradeCompleteRepository;
/*

frontend

api

controllers layer (socket io listeners, calls service, responds)
service layer (pulls together various repo functions and returns a contracty style thing)
repository layer (custom collection of open trade - get me X from db)
entity layer (open trade entity)

*/
//# sourceMappingURL=OpenTradeComplete.js.map